(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flavor-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('flavor-picker')) {
    const sizeKey = (title = '') => `${title.toLowerCase().replace(/\s/g, '').split('oz')[0]}oz`;

    class FlavorPicker extends HTMLElement {
      connectedCallback() {
        this.prefetched = new Set();
        ['pointerenter', 'touchstart', 'focusin'].forEach((type) =>
          this.addEventListener(type, (event) => this.prefetch(event.target.closest?.('a[href]')), {
            capture: true,
            passive: true,
          }),
        );

        const init = () => {
          if (!window.theme?.pubsub || this.unsubscribe) return;
          this.unsubscribe = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (String(data?.productId) !== this.dataset.productId || !data.variant) return;
            this.keepSize(sizeKey(data.variant.title));
          });
        };
        window.theme?.pubsub ? init() : document.addEventListener('DOMContentLoaded', init, { once: true });
      }

      disconnectedCallback() {
        this.unsubscribe?.();
        this.unsubscribe = undefined;
      }

      // Point every other flavor at its variant with the same size, if it has one
      keepSize(size) {
        this.querySelectorAll('a[data-flavor-url]:not([aria-current])').forEach((link) => {
          let sizes = {};
          try {
            sizes = JSON.parse(link.dataset.sizeVariants || '{}');
          } catch (error) {}
          link.href = sizes[size] ? `${link.dataset.flavorUrl}?variant=${sizes[size]}` : link.dataset.flavorUrl;
        });
      }

      prefetch(link) {
        if (!link || link.hasAttribute('aria-current') || this.prefetched.has(link.href)) return;
        this.prefetched.add(link.href);
        const hint = document.createElement('link');
        hint.rel = 'prefetch';
        hint.href = link.href;
        document.head.appendChild(hint);
      }
    }
    customElements.define('flavor-picker', FlavorPicker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-details"] && !Shopify.designMode) return;
  try {
    class DescriptionReadMore extends HTMLElement {
  constructor() {
    super();
    this.initClick();
  }
  initClick() {
    this.querySelector('a').addEventListener('click', ((event) => {
      event.preventDefault();
      const previousSibling = this.previousElementSibling;
      if (previousSibling) { 
        previousSibling.classList.toggle('expand-content');
        if (previousSibling.classList.contains('expand-content')) {
          this.querySelector('a').innerText = this.dataset.showLess;
        } else {
          this.querySelector('a').innerText = this.dataset.showMore;
        }
        setTimeout(() => {
          refreshScrollTriggersForSubsequentSections(this);
        }, 300);
      }
    }))
  }
}
customElements.define('description-read-more', DescriptionReadMore);

// Title block "Show selected variant as title": swap the title text when the variant changes
(function subscribeVariantTitle() {
  if (!window.theme?.pubsub) {
    document.addEventListener('DOMContentLoaded', subscribeVariantTitle, { once: true });
    return;
  }
  theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, ({ data }) => {
    if (!data?.variant?.title) return;
    document.querySelectorAll(`[data-variant-title][data-product-id="${data.productId}"]`).forEach((title) => {
      title.textContent = data.variant.title.replace(/ \/ /g, ' ');
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-description')) {
    class VariantDescription extends HTMLElement {
      connectedCallback() {
        const init = () => {
          if (!window.theme?.pubsub || this.unsubscribe) return;
          this.unsubscribe = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (String(data?.productId) !== this.dataset.productId || !data.variant) return;
            this.render(data.variant.id);
          });
        };
        window.theme?.pubsub ? init() : document.addEventListener('DOMContentLoaded', init, { once: true });
      }

      disconnectedCallback() {
        this.unsubscribe?.();
        this.unsubscribe = undefined;
      }

      render(variantId) {
        const content = this.querySelector('[data-variant-description-content]');
        const source =
          this.querySelector(`template[data-variant-description="${variantId}"]`) ||
          this.querySelector('template[data-variant-description="default"]');
        if (!content || !source) return;
        content.innerHTML = source.innerHTML;
        // Hide the wrapper when neither the variant nor the product has a description
        this.closest('[data-variant-description-wrapper]')?.toggleAttribute(
          'hidden',
          !source.content.textContent.trim(),
        );
      }
    }
    customElements.define('variant-description', VariantDescription);
  }
  } catch(e) { console.error(e); }
})();

})();
